import BC from '../init';

const conversionRates = {
    euro: 1,       // Base currency
    dollar: 1.1,
    pound: 0.85
};
function formatCurrency(value, currency) {
    const currencySymbols = {
        euro: '€',
        dollar: '$',
        pound: '£'
    };
    const symbol = currencySymbols[currency.toLowerCase()] || '€';

    // Custom formatter for the number
    const formattedNumber = value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    return `${symbol} ${formattedNumber}`;
}
export default BC.Methods.changeCurrency = () => {
    const currencySwitchers = document.querySelectorAll('select[data-function="changeCurrency"]');

    // Load saved currency from local storage
    const savedCurrency = localStorage.getItem('selectedCurrency');
    if (savedCurrency) {
        currencySwitchers.forEach(currencySwitcher => {
            currencySwitcher.value = savedCurrency;
        });
        updatePrices(savedCurrency);
    }

    // Add event listener for currency change
    currencySwitchers.forEach(currencySwitcher => {
        currencySwitcher.addEventListener('change', function () {
            console.log('change');
            const selectedCurrency = currencySwitcher.value;
            localStorage.setItem('selectedCurrency', selectedCurrency);
            updatePrices(selectedCurrency);
        });
    });

    function updatePrices(currency) {
        const prices = document.querySelectorAll('.change-price');
        prices.forEach(priceElement => {
            const basePrice = priceElement.getAttribute('data-base-price');
            // Check if base price is a number, ignore if it's a string like "Price upon request"
            if (!isNaN(basePrice)) {
                const convertedPrice = parseFloat(basePrice) * conversionRates[currency];
                priceElement.textContent = formatCurrency(convertedPrice, currency);
            } else {
                // If the base price is not a number, leave it as is
                priceElement.textContent = basePrice;
            }
        });
    }
};
